import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject } from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { KeyValueObject } from "../types/general";

const authMiddleware = (lang: string, additionalHeaders?: KeyValueObject): ApolloLink => {
    return new ApolloLink((operation, forward) => {
        const headers: Record<string, string> = {
            lang: lang,
        };
        if (additionalHeaders) {
            Object.assign(headers, additionalHeaders);
        }
        operation.setContext({
            headers: headers,
        });
        return forward(operation);
    });
};

export const useAppApolloClient = (
    cache: InMemoryCache,
    lang: string,
    uri: string,
    headers?: KeyValueObject,
): ApolloClient<NormalizedCacheObject> => {
    const uploadLink = createUploadLink({
        uri: uri,
        credentials: "include",
    });
    const combinedLink = ApolloLink.from([authMiddleware(lang, headers), uploadLink]);
    return new ApolloClient({
        link: combinedLink,
        cache,
        defaultOptions: {
            mutate: {
                errorPolicy: "all",
            },
        },
        assumeImmutableResults: true,
    });
};
